<div class="form-shell" [class.blocked]="blocked()">
  <div class="form-shell-header">
    <ng-content select="[assistantFormHeader]" />
  </div>

  <div class="form-shell-fields">
    <ng-content select="[assistantFormFields]" />
  </div>

  @if (submitting()) {
    <mat-progress-bar mode="indeterminate" />
  }

  @if (errorMessage()) {
    <div class="form-shell-error">{{ errorMessage() }}</div>
  }

  <div class="form-shell-actions-bar">
    <div class="form-shell-actions-container">
      <ng-content select="[assistantFormActions]" />
    </div>
  </div>

  @if (blocked()) {
    <div class="form-shell-interaction-blocker" aria-hidden="true"></div>
  }
</div>
